export const ADD = {
    REQUEST: 'DELIVERY_NOTE.RETURN.ADD.REQUEST',
    SUCCESS: 'DELIVERY_NOTE.RETURN.ADD.SUCCESS',
    FAILED: 'DELIVERY_NOTE.RETURN.ADD.FAILED',
};

export const CLEAR_STATE = 'DELIVERY_NOTE.RETURN.ADD.CLEAR_STATE';

export const RESET_ERROR = 'DELIVERY_NOTE.RETURN.ADD.RESET_ERROR';
